module.exports = "<button class=\"btn btn-default es-vertex-button\" (click)=\"openVertexModal()\">\n  {{Yiit.t('Edit vertices')}}\n</button>\n"